import { DESIGN_THEMES, type DesignThemeId } from '@innermate/shared';

export type Theme = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'innermate.theme';

export function loadTheme(): Theme {
  if (typeof window === 'undefined') return 'system';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark' || stored === 'system') return stored;
  return 'system';
}

export function saveTheme(theme: Theme): void {
  window.localStorage.setItem(STORAGE_KEY, theme);
}

export function resolveTheme(theme: Theme): 'light' | 'dark' {
  if (theme === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return theme;
}

/** `<html>` 의 클래스를 라이트/다크에 맞게 토글. */
export function applyTheme(resolved: 'light' | 'dark'): void {
  const root = document.documentElement;
  root.classList.toggle('dark', resolved === 'dark');
  root.classList.toggle('light', resolved === 'light');
}

/**
 * `<html>` 에 `theme-<id>` 클래스 부착. 기존 theme-* 클래스는 제거 후 새로 설정.
 * 라이트/다크 클래스와는 독립 — applyTheme 와 충돌하지 않는다.
 * 클래스가 전혀 붙지 않더라도 (서버 응답 전 첫 페인트, 온보딩 부트스트랩 모드)
 * index.css 의 `:root` 베이스 셀렉터가 default 테마 토큰을 제공하므로 깨지지 않는다.
 */
export function applyDesignTheme(id: DesignThemeId): void {
  const root = document.documentElement;
  for (const t of DESIGN_THEMES) {
    root.classList.toggle(`theme-${t.id}`, t.id === id);
  }
}
